import Vue from 'vue';
import Component from 'vue-class-component';
import { AuthorisationManager, Identity, Icon } from 'wc-lib';
import { Prop } from 'vue-property-decorator';
import { Service } from '../service';
import { Favourite } from '../model/favourite';
import { Links } from './links';

require('../../icons/trash.svg');
require('../../icons/edit.svg');
require('../../icons/move.svg');
require('../../icons/tick.svg');

@Component({
  template: require('./edit-favourite-item.html'),
  components: {
    'wc-icon': Icon
  }
})
export class EditFavouriteItem extends Vue {
  @Prop()
  favourite: Favourite;
  editing: boolean = false;

  toggleEdit() {
    this.editing = !this.editing;
  }

  async editFavouriteText() {
    if (this.favourite.menuItemText.trim() != '') {
      await Service.editFavourite(this.favourite.menuItemId, this.favourite.menuItemText);
      this.toggleEdit();
    }
  }

  async removeFavourite() {
    await Service.removeFavourite(this.favourite.menuItemId);
    this.$store.commit('app/setFavourites', (await Service.getFavourites()).favourites);
  }
}



// WEBPACK FOOTER //
// src/components/edit-favourite-item.ts